<template>
  <Styled>
    <div class="autocomplete-content">
      <div class="icon-search">
        <span class="icon material-icons"> search </span>
      </div>
      <input
          type="search"
          id="search"
          autocomplete="off"
          :placeholder="placeholder"
          :name="name"
          class="input"
          v-model="search"
          @focus="onFocus"
          @blur="onBlur"
          @keydown="customAction"
      />
      <div :class="`options-container${focus ? ' open' : ''}`">
        <ul
            class="options-ul"
            v-if="
            (focus && Array.isArray(options) && options.length == 0) ||
            isLoading
          "
        >
          <li class="option-item" v-if="!isLoading">
            <a class="option-link">Digite un nombre o un documento</a>
          </li>
          <li class="option-item" v-if="isLoading">
            <a class="option-link">Cargando...</a>
          </li>
          <li
              class="option-item"
              v-if="!isLoading && search && search.length == 0"
          >
            <a class="option-link">Escriba para buscar...</a>
          </li>
          <li
              class="option-item"
              v-if="
              !isLoading && search && search.length > 0 && options.length == 0
            "
          >
            <a class="option-link">Sin resultados...</a>
          </li>
        </ul>
        <ul class="options-ul" v-if="!isLoading">
          <li
              class="option-item"
              v-for="(option, index) in options"
              :value="index"
              :key="index">
            <a class="option-link" @click="onClickItem(option)">
              <span class="label user-container ml-1">
                <span class="username">
                  {{ option.name }}
                </span>
                <span class="identification">
                  {{ option.identification }}
                </span>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </Styled>
</template>

<script>
import {ROUTES} from "@/global/api_routes";
import Styled from "./styles";
import {get as getProp} from "object-path";

export default {
  components: {Styled},
  props: ["value", "placeholder", "name", "identification"],
  data: () => ({
    search: "",
    isLoading: false,
    list: [],
    focus: false,
    interval: null,
    options: [],
  }),
  mounted() {
    this.search = this.identification;
  },
  watch: {
    value: function () {
      this.search = getProp(this.value, "identification");
    },
    search: function () {
      if (this.search && search.length == 0) {
        return;
      }
      this.onSearch();
    },
  },
  methods: {
    clean() {
      this.search = null;
    },
    customAction(event) {
      const code = event.which || event.keyCode;
      if (code == 27) {
        this.focus = false;
      }
    },
    onFocus() {
      this.focus = true;
    },
    onBlur() {
      setTimeout(() => {
        this.focus = false;
      }, 200);
    },
    onClickItem(item) {
      this.$emit("input", item);
    },
    onFinish(event, options) {
      this.isLoading = false;
      if (!Array.isArray(options)) {
        return;
      }
      this.options = options;
    },
    getUsers({action, searchQuery, callback}) {
      if (action === "ASYNC_SEARCH") {
        if (!searchQuery || searchQuery.length < 2) {
          return;
        }
        this.$http
            .get(ROUTES.DASHBOARD.USERS.SEARCH, {
              params: {
                search: searchQuery,
              },
            })
            .then(({data}) => {
              if (data.code > 0) {
                this.options = data.info;
                callback(null, this.options);
                return;
              }
              this.options = [];
              callback(null, []);
            });
      }
    },
    onSearch() {
      const search = this.search;
      this.isLoading = true;
      if (this.interval) {
        clearTimeout(this.interval);
      }
      this.interval = setTimeout(() => {
        this.getUsers({
          action: "ASYNC_SEARCH",
          searchQuery: search,
          callback: (event, options) => this.onFinish(event, options),
        });
      }, 500);
    },
  },
};
</script>
